class layerEvents {
	
	map = null;
	cfg = {};
	lastHoveredId = null;
	lastKnownHoveredId = null;
	selectedPlots = [];
	hoveredPlots = [];
	updatedPlots = [];
	
	constructor(map, cfg) {
		this.map = map;
		this.cfg = {...this.cfg, ...cfg}
		
		

	}
	clearSelectedPlots(){
		
		if(this.map.getSource("cadastral-all") && this.map.getLayer("cadastral-unknown-fill")){
			this.selectedPlots = [];
			this.highlightSelectedPlots();
		}
		
	}
	
	highlightSelectedPlots(updatedPlots){
		
		if(updatedPlots && updatedPlots.length){
			this.updatedPlots = [...this.updatedPlots, ...updatedPlots];
			//console.log(this.updatedPlots);
		}
		var updatedIds = this.updatedPlots.map((a)=>{return a.properties.map((p)=>{return p.id;})});
		
		updatedIds = updatedIds.flat();
		
		var allVisible = [...this.selectedPlots, ...updatedIds];
		
		this.map.setPaintProperty(
			'cadastral-unknown-fill', 
			'fill-color', 
			['case', ['in', ['get', 'vindrid'], ["literal", updatedIds]], "#ffffff", ['case', ['in', ['get', 'vindrid'], ["literal", this.selectedPlots]], "#e5e9f1", '#ffffff']] // add another condition for the updated tiles
		);
		this.map.setPaintProperty(
			'cadastral-unknown-fill', 
			'fill-opacity', 
			['case', ['in', ['get', 'vindrid'], ["literal", allVisible]], 1, 0]
		);	
	}
	
	//cadastral layers events
	handleCadastralUnknownClick(){
		var self = this;
		this.map.on('click', ['cadastral-unknown-fill'], (e) => {
			
			
			
			
			if(!e.originalEvent.shiftKey)
				this.selectedPlots = [];
			
			var plot = e.features[0];
			var idx = self.updatedPlots.findIndex((a)=>{
				var subidx = a.properties.findIndex((b)=>{return b.id == plot.properties.vindrid});
				return subidx > -1;
			});
			if(idx > -1 ) {
				this.cfg.setOwner(self.updatedPlots[idx]);
				this.clearSelectedPlots();
				return;
			}
			const index = self.selectedPlots.indexOf(plot.properties.vindrid);
			if (index > -1)
				self.selectedPlots.splice(index, 1);
			else
				self.selectedPlots.push(plot.properties.vindrid);

			self.highlightSelectedPlots();

			var info = {
				vindrid:self.selectedPlots.join(", "),
				selectedPlots:self.selectedPlots,
				cadastralLayer:true, //mark request as comming from cadastral map, neded because we need to diferentiate requests from cadastral map and sceanario properties without known owner
				callback:(info)=>{
					
					if(info.length)
						info.map((o)=>{
							if(o.first_name)
								o.fullName = o.company_name ? o.company_name : o.first_name+' '+o.last_name;  //info comes from the martin tile server
							if(o.firstName)
								o.fullName = o.companyName ? o.companyName : o.firstName+' '+o.firstName; //info comes from vindr api
							
							o.cadastralLayer = true;
							//filter repeated id's, for properties with more than one plot
							o.properties = o.properties.filter((value, index, array)=>{
								return array.findIndex((obj)=>{return obj.id == value.id}) === index;
							});
						})
					if(info.length == 1)
						self.cfg.setOwner(info[0]);
					self.highlightSelectedPlots(info);
				}
			}
			this.cfg.setOwner(info);
		});
	}


};
export default layerEvents